import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import View, { ViewOpts } from '@play-co/timestep-core/lib/ui/View';
import { ImageScaleView, QuickViewPool } from '@play-co/timestep-core/ui';
import i18n from 'src/lib/i18n/i18n';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { DecorationThemeID } from 'src/replicant/data/DecorationItems.schema';

export type GachaProbabilityItemData =
  | {
      tier: number;
      // Number from 0 to 10000, like they are in gacha buckets. 2890 = 28.9%
      probability: number;
    }
  | {
      title: string;
    };

let starsPool: QuickViewPool<ImageScaleView>;

export function getStarPool() {
  if (!starsPool) {
    starsPool = new QuickViewPool(
      () =>
        new ImageScaleView({
          image: 'assets/ui/gacha/icons/star.png',
          width: 104,
          height: 106,
          scaleMethod: 'contain',
        }),
    );
  }
  return starsPool;
}

export class GachaProbabilityItem extends View {
  private bg: ImageScaleView;
  private container: FlexBoxView;
  private title: LangBitmapFontTextView;
  private tier: FlexBoxView;
  private probability: LangBitmapFontTextView;

  constructor(opts: ViewOpts) {
    super({
      width: 558,
      height: 272,
      ...opts,
    });

    this.bg = new ImageScaleView({
      superview: this,
      image: 'assets/ui/shared/frames/rounded_rect_white.png',
      width: this.style.width,
      height: this.style.height,
      scaleMethod: '9slice',
      opacity: 0.5,
      sourceSlices: {
        horizontal: { left: 16, right: 16 },
        vertical: { top: 16, bottom: 16 },
      },
    });

    this.container = new FlexBoxView({
      superview: this,
      width: this.style.width,
      height: this.style.height,
      flex: {
        alignItems: 'center',
        justifyContent: 'space-evenly',
        paddingLeft: 16,
        paddingRight: 16,
      },
    });

    this.title = new LangBitmapFontTextView({
      superview: this.container,
      align: 'left',
      verticalAlign: 'center',
      size: 28,
      font: 'Body',
      color: '#BF8147',
      width: this.style.width,
      height: this.style.height,
      visible: false,
    });

    this.tier = new FlexBoxView({
      superview: this.container,
      width: this.style.width * 0.5,
      height: this.style.height,
      flex: {
        alignItems: 'center',
      },
    });

    this.probability = new LangBitmapFontTextView({
      superview: this.container,
      align: 'right',
      verticalAlign: 'center',
      size: 22,
      font: 'Body',
      color: '#9A7171',
      width: this.style.width * 0.5,
      height: this.style.height,
    });
  }

  public setData(data: GachaProbabilityItemData) {
    if ('title' in data) {
      this.title.localeText = () => data.title;
      this.title.show();
      this.tier.hide();
      this.probability.hide();
      this.bg.hide();
      return;
    }

    this.title.hide();
    this.tier.show();
    this.probability.show();
    this.bg.show();

    const probabilityToDisplay = Number(data.probability.toFixed(2));
    this.probability.localeText = () => `${probabilityToDisplay}%`;

    this.tier.removeAllSubviews();
    for (let i = 0; i < data.tier; i++) {
      const star = getStarPool().obtainView();
      star.updateOpts({
        width: this.style.height - 16,
        height: this.style.height - 16,
      });
      this.tier.addSubview(star);
    }
  }
}
